
import Vue from 'vue';
import moment from 'moment';
import axios from '../../plugins/axios.js';
import { Provide, Component, Ref } from 'vue-property-decorator';
import ConfirmRefundModal from './modals/ConfirmRefundModal.vue';
import AddRefundRecordModal from './modals/AddRefundRecordModal.vue';
@Component({
    components: {
        ConfirmRefundModal,
        AddRefundRecordModal,
    },
})
export default class TransactionRefundManagement extends Vue {
    @Provide() private refundRecords: any[] = [];
    @Provide() private totalRecords: number = 0;
    @Provide() private pageSize: number = 10;
    @Provide() private queriedCondition: { [index: string]: any } = {
        tradeNo: null,
        createdAt: [],
        refundedAt: [],
        phone: '',
        minimumAmount: null,
        maximumAmount: null,
        page: 1,
    };
    @Provide() private loading: boolean = false;
    @Provide() private pickerOptions = {
        shortcuts: [
            {
                text: '今天',
                onClick(picker) {
                    const start = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                    const end = moment().format('YYYY-MM-DD HH:mm:ss');
                    picker.$emit('pick', [start, end]);
                },
            },
            {
                text: '前一天',
                onClick(picker) {
                    const start = moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
                    const end = moment().subtract(1, 'day').endOf('day').format('YYYY-MM-DD HH:mm:ss');
                    picker.$emit('pick', [start, end]);
                },
            },
            {
                text: '本月(完整月)',
                onClick(picker) {
                    const start = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
                    const end = moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
                    picker.$emit('pick', [start, end]);
                },
            },
            {
                text: '本月(至当前)',
                onClick(picker) {
                    const start = moment().startOf('month').format('YYYY-MM-DD HH:mm:ss');
                    const end = moment().format('YYYY-MM-DD HH:mm:ss');
                    picker.$emit('pick', [start, end]);
                },
            },
            {
                text: '前一月',
                onClick(picker) {
                    const start = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD HH:mm:ss');
                    const end = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD HH:mm:ss');
                    picker.$emit('pick', [start, end]);
                },
            },
        ],
    };
    @Ref() private readonly confirmRefundModal;
    @Ref() private readonly addRefundRecordModal;

    private mounted() {
        this.requestRefundRecords();
    }

    private queryRecords() {
        this.queriedCondition.page = 1;
        this.requestRefundRecords();
    }

    private changePage(page: number) {
        this.queriedCondition.page = page;
        this.requestRefundRecords();
    }

    private requestRefundRecords() {
        this.loading = true;
        axios.get('/api/v1/transaction/refund-records', this.queriedCondition).then(({ records, total }) => {
            this.loading = false;
            this.refundRecords = records;
            this.totalRecords = total;
        }).catch((error) => {
            this.$message.error(error);
        });
    }

    private refundStatusText(status: number) {
        return status === 0 ? '退款中' : '已退款';
    }

    private refundChannelText(channel: number | null) {
        switch (channel) {
            case 0: return '原路返回';
            case 1: return '微信转款';
            case 2: return '支付宝转款';
            case 3: return '银行转款';
            default: return '';
        }
    }

    private openConfirmRefundModal(record: any) {
        this.confirmRefundModal.$emit('open', record);
    }

    private openAddRefundRecordModal() {
        this.addRefundRecordModal.$emit('open');
    }
}
